import React from "react";
import {FormControl, FormHelperText} from "@mui/material";
import {CommonProps} from "./types/types";
import {StatusUpdateAnswer} from "../types/UpdatePartyObject";
import {withSharedMemo} from "./memo/memoComponent";
import {BaseInput} from "./BaseInput";

interface TextFieldMemoProps extends CommonProps {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    type?: "text" | "number";
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
    style?: React.CSSProperties;
    endAdornment?: React.JSX.Element;
}

const TextFieldMemo = ({
                           id,
                           value,
                           onChange,
                           onFocus,
                           required,
                           type = "text",
                           errorText,
                           style,
                           status = StatusUpdateAnswer.NONE,
                           editable,
                           endAdornment
                       }: TextFieldMemoProps) => {
    const hasError = !!errorText;
    return (
            <FormControl
                    error={hasError}
                    disabled={!editable}
                    required={required}
                    style={style}
                    fullWidth
            >
                <BaseInput
                        id={id}
                        value={value}
                        onChange={onChange}
                        onFocus={onFocus}
                        editable={editable}
                        required={required}
                        hasError={hasError}
                        type={type}
                        status={status}
                        endAdornment={endAdornment}
                />

                {hasError && <FormHelperText error>{errorText}</FormHelperText>}
            </FormControl>
    );
};

export default withSharedMemo(TextFieldMemo);